/* eslint-disable max-len */
import { createMachine } from 'xstate';
import { Navbar2Element, NavbarBrandLogo, NavbarItem } from '@typedream/core';
import { Path } from 'slate';

type MenuType = 'brand' | 'menu' | 'endMenu';

// TODO(@ibedwi): check which part of navbar that trigger the menu option
type MenuOptionsContext = {
  menuType?: MenuType,
  menuIndex?: number,
  dataNavbarNodeReference?: Path,
  dataNavbar?: Navbar2Element,
  optionsColors: Record<string, string>,
  optionsFontFamilies: Record<string, string>,

  selectedFontFamily: string, // Default to: DEFAULT_FONT_FAMILY_NAME

  // UI related state
  uiIsSidebarOpen: boolean;
  uiShowLinkSuggestion: boolean;
};

type MachineServices = {
  uploadImage: {
    data: string;
  };
};

// eslint-disable-next-line operator-linebreak
export const menuOptionsMachine =
  /** @xstate-layout N4IgpgJg5mDOIC5QDkCGA3ARqgTgWTADsBXASQBcwBbAUQgEtyB7HAMQGU8A6UiAGzABiAPLIA+gGEAMqQkBpMaQAqNPAG0ADAF1EoAA5NYjek0K6QAD0QBaAMwA2AOxdH9+7YAcrgKxfbATg97ABoQAE8bABZ-LgBGIO9HD3iAJg17dKCAXyzQtCxcAhIKajpGFg5uXgERcWlZBSlhAHFhMRopVRpkJU0dJBADI3ITMwGrBFiUmNtIx1i5-zmU+xS50IiEa0iPLg0Uzw0PJe9bU6nInLyMbHwiMkpaBmY2Ti52AAsmAHd6QigAATsMDkEb-AFFYi1MTsGhKJSkZDNMR4boAVTEACEpGiAEp9cxDYymcwTayODSRLjeeKJdzedyzSIbGwBLgeHaxJK2earDT7K4gfK3SElJ7lV7cT4-P6A4Gg2UQ+5cADqqGM4IAZiwAcRYGAcAByWAA1AAYxGpmhsM6EiUYgRSk6BIGRMtY1AZIWni4kVOmQ8iUitlsKRZkzOMUcKQ8AQ0jlm0aWguFhXuYrKL0q7y+v3B8rBgMhqvVhYB2pwuv1RpN5vd0Pq8jErFEvW0hMMxI9lhsrl2kWiGn8tliGm8-kc0fDsQcuxnMeHPICiQ8KZuaeKj0zFTe0rzcpBZeLao1gIrVYNxtNFtGDZkTZUAA17RJhE1cSj0S79J33aSbLEsT2N4LhuAs-gxr4biONODj2FwawpN4+xBJE-JTGuBR3JupTPDuUq5oqBaKsepaKueeqXrWN5WqIkj3o0LRtKiyBot+gy-qM-5bBycQ7Kc0T2Mkpw0uGXjOGkDIHP4-g0kO-iYSK6Zbnhko5jK+aHiRyonmWFHVleda3nRjaMa0n6sWosT9D+wxceMiDxFSlKJDy45CfGsnhou7JpI4-j2EBQ7yYpG4PLhErZnuRFaeCpGnuWOqUTW171iZDFiE05ksWxKQ2Rxdkkg5CAZM49iREBXKOOOmTMuEiCBLsSzBscckeOkoXYeF4pZruhGaQqcU6WRWpJQZ1FpeINo0HamWIgoOXsW69melEyR7PYsk7LGAQZB4sG+FwGT8q5zU7JcuRCuuXUZqpUX9Qeg1FsNCX6VRqXGXUAASACCSI0HNyAKMIAAK3RiMgNAqg6P2YktnFFatWynCk7KzP4sTIWkMZeOG-nOEONKbb4XjIQpl2pjdKmRX1GmPUeL16WN71GbR4gACIdHCAOLe2roI92XoaCGvnSd4viREh-jhtsuz7Icxx+mcI7eJ1orU71BF00CsXPSQJavczKWs4Q1pc7NSgAJpgxZbF87ZXbcdY0xHXGgWbR47UpBcsExqBaGOBV6QyarFPXerEWa+p+4609Sr60ojACDrAgWpADa-f9DrKM69sFY7xXWAsKxxIFE6bU4MmS9OpwxFMQQZOOKwrBd1xYRHPX4dHMVx8WifkMnwKp5QEDQtieLZ06NDw4VgsAaGMSyaTxwHEEU71ZMaFzgyHgHIHyGTikavKZHXfRQNDP6+fgKsKY5Dx1CdHjx+LY9LbM8F0j1jlfBAXTLMoYkgZBCBvBY8ZfQMgcGkTwTgeTHxwp3NS19Y6X2IN3cEt9CD30hBnP6zQAavzbPlZaiMexbATFSaqFIXIyS5AOGuSEjqRAyCkGM8ZqrkzbkpBB24kEPRQdpK+-CJBMD4DqKQ9BYD33YMQTAD9cFZ1fO+D+f5C6jj9FwHkitvDTCSK1GuI49iS3mL4Mc0x7DwO6rw+62tiJDSEdrERYjKwSKkUCWR8in44g-Eo4QH5ebEIFk7EOR1vY6KHAAoS+1QEBwge4DQUx94rFXGHduJ9EE2JjnYvWaDcTUCYOgRUUgmBQCYIIFRK0yHe1sFwYck4nBDmmAcbw04Ek1NDJLM4QkILe0cJY26NMtZZN1g-LgEjCAAGsH4pzAGnUeJlM74MBnICppCyQpApJomkDhZI0knAkAxGhNFCSQjOUMUt+kazPvw7JozxlTMhDMuZY9vHLPfnnEhc8tgxlRtEWIId3BOFHC0mJ4C-TlX5KsY4wtbCXNPnw2xIy+5hD0GAaZQ9ZkjxeRPK2NsAkdlnk7aMLgRyJi2jSEOsF-K+m6SGb2XgxxwoybTYZvdlRKBRWix5GLnkLLwQDXF08PlBOKtVFwHIGTRiQt4aI0tQEypAtEAIGNmEBFcH01J3CrF3TeLpRUZpUCEHQKgE0YB0BEHvuefUccqD3EEBYKRqBKBcFQJqSgOAAAUyEACUghKYd2sbqkagIDVGpNQCM1FrEqVmtWWW1JBVlfKLodeJMkhyrAZGOWw4ZgzwX+QOeYCwZybVbldNJPCdVDKKSUpgTzsGQHoKgM28JETIhylibxibuIyt2AcVhRwlX7H2DLda44RI0g2W4AUmqwoDKjsg4ppS61KgYE2p+P0HxtFhC2pE7zAmEuKl4dkNJmHMM2sLcqObZhHUDPGVyIYghHxnVTeFmTq1Lp5fW1dPB+BCD5VnLKwgu3FUAswklmNPYLElUhcMvTfRDmSL00MEGmWBqreCRdtbP0rsbT+modE0QgyaD9dmig8A-XwcBpGgEZyaICKSvaM4hzhlmEcyWTGAqIZ0RY59AbK3oMBJh5dBBv1oj0GI1ADBwT0CoKgGAggICmDAFwP46AmATOU8QcTTBJOkFkzAKjZDRyBWpEcDG1VkIMhzYEeDu9oJrCmCOVD-GF01uEw21AXAxMSak4CGTcmhAGhwCwLg4mnUVioFwLTPm9MBcMxMdRqN4xnElkseMiSc2UjiO1dq8QEx0gnM5wZBsyyhuNaa81WDo0An1MPAEtrV32sdc6117qvUaF9f69JaGSv6sNeViNlXLU6lq5i+rHn4uICldSVhZwYwJnoyCzY3soz8mqo5-wRxAoaq4bOq5CKY5CewyJ3D1Q-3fX5ZlJiMJSAAC0hX7s-kZ+IctuRAQxhK-yYlUYUnavs8ziQDg5EuoQJgEA4DmC6xWwZBKntegEhA2wAYgx0plg530KwEnIUDOdcWRWo5ndh6or+o4YiIdla4DGgRVgy0xjU4cgZAITrODOHbZatVzuuYitlJAieVK9DseCStkeB1RxvCkMRSqwIZBBQOKTdsvuZeh+mgi0F6tGpWZKhkaLdk+U7EcsQSUcix+LBMsRvJip5CsWYyRCZwN491lzNykXsqTmiz9kA+drPnqsBCsvjh6OOFMaczDfl+mmPsCcwYGT4656y1BAmASYPrbz-mB6v6uHgiTJIvINkkxD4dcWI5uTpdOLCh30P53O552g5BTjxGSOkR4yEXuk2AX2FspwwkwkPpDyZwOOxIIY2FkhWPB2e4J7yVQAp76mCt+4tb9k-yORwQHKGacpPfSBACjJUmEF5fs726+llE-VdjL+A8+4dbPdp7h6yGSmiNlpCHMGeScrNgLCcC4NI575i24CmPm+hfGfhyqiuimAMPDfg7MTmQiBMBByL0sBDLpOAXvBLlp7JLIOHZoAUGglGVuGpGlVlaiMvGsQPPoXNMJLsHEuGEjouLLBqcOyLln6GbsLAsDgcrgCEdhAWNidqgOQUjJ7L8u9kkGkJjPMO-lEC4P5MGCGP5MXFEhwYntwXVnwXhmAAIWQsOGxiIbvFjhIbBvEHENGL4CluOJyDxgrnxsVq5h+jwRaDhp5t5jpr5gCP5jAJoQlhsjUvsPIQmEJOOIGJlv2D-gOAHFyDOEoeriGv1gQUNtVqNg4Q1o2p4YgNAtSJxsrDJGsD-AwT9vyJSO4ByDODHsDkAA */
  createMachine({
    tsTypes: {} as import('./MenuOptions.fsm.typegen').Typegen0,
    id: 'NavbarMenuItemEditorFSM',
    initial: 'Idle',
    states: {
      Idle: {
        on: {
          ON_CLICK_ITEM: {
            target: 'Waiting canvas event for setting menu',
            description: 'Clicking the item will open the setting menu. We also assign the reference of the menu in the editor here. A menu might be one of `menu`, `endMenu`, or `brand`',
            actions: ['assignMenuNodeRef', 'assignNavbarToContext'],
          },

          ON_CLICK_LOGO_ELEMENT: {
            target: 'Waiting canvas event for select media',
            actions: ['assignMenuNodeRef', 'assignNavbarToContext'],
          },
        },
      },

      'Showing Setting Menu': {
        initial: "Waiting for user's action",
        tags: ['ui:show_setting_menu'],
        states: {
          "Waiting for user's action": {
            on: {
              ON_SELECT_TITLE: {
                target: 'Title Selected',
              },

              ON_CLICK_FONT: {
                target: 'Showing Font Menu',
              },

              ON_CLICK_TEXT_COLOR_MENU: {
                target: 'Showing Color List Sub Menu',
              },

              ON_CLICK_BACKGROUND_COLOR_MENU: {
                target: 'Showing Background Color List Sub Menu',
              },

              ON_CLICK_LOGO_MENU: [{
                target: "Waiting for user's action",
                cond: 'isNotNavbarBrand',
                internal: true,
              }, {
                target: 'Removing Logo',
                cond: 'isLogoExist',
              }, '#NavbarMenuItemEditorFSM.Waiting canvas event for select media'],

              ON_SELECT_LINK_MENU: 'Link Menu Selected',

              ON_CHANGE_LINK_OPEN_NEW_TAB: {
                target: "Waiting for user's action",
                internal: true,
                actions: ['assignLinkToContext', 'effectUpdateSlateNodeLink'],
              },

              ON_DELETE_MENU: {
                description: '',
                target: '#NavbarMenuItemEditorFSM.Idle',
                cond: 'isNotNavbarBrand',
                actions: ['deleteMenuFromContext', 'effectUpdateSlateNode', 'cleanUpContext'],
              },

              ON_SELECT_TYPE_MENU: {
                target: 'Type Menu Selected',
                cond: 'isNotNavbarBrand',
              },
            },
          },

          'Title Selected': {
            on: {
              ON_CHANGE_TITLE: {
                actions: ['assignTitleToContext', 'effectUpdateSlateNode'],
                target: 'Title Selected',
                internal: true,
              },
              ON_BLUR_TITLE: {
                target: "Waiting for user's action",
              },
            },
          },

          'Showing Font Menu': {
            tags: ['ui:show_sidebar', 'ui:show_font_list'],
            on: {
              ON_BLUR_FONT_MENU: "Waiting for user's action",
              ON_CHANGE_FONT: {
                target: 'Showing Font Menu',
                internal: true,
                actions: ['assignFontToContext', 'effectUpdateSlateNode'],
              },
            },
          },

          'Showing Color List Sub Menu': {
            tags: ['ui:show_sidebar', 'ui:show_color_list'],
            on: {
              ON_CHANGE_COLOR: {
                actions: ['assignTextColor', 'effectUpdateSlateNode'],
              },
              ON_BLUR_COLOR_MENU: "Waiting for user's action",
            },
          },

          'Showing Background Color List Sub Menu': {
            tags: ['ui:show_sidebar', 'ui:show_background_color_list'],
            on: {
              ON_CHANGE_BACKGROUND_COLOR: {
                actions: ['assignBackgroundColor', 'effectUpdateSlateNode'],
              },
              ON_BLUR_BACKGROUND_COLOR_MENU: "Waiting for user's action",
            },
          },

          'Removing Logo': {
            entry: ['removeLogoFromContext', 'effectUpdateSlateLogo'],

            always: "Waiting for user's action",
          },

          'Link Menu Selected': {
            tags: ['ui:show_link_menu'],
            on: {
              ON_CHANGE_LINK: {
                target: 'Link Menu Selected',
                internal: true,
                actions: ['assignLinkToContext', 'effectUpdateSlateNode'],
              },

              ON_BLUR_LINK_MENU: "Waiting for user's action",
            },
          },

          'Type Menu Selected': {
            tags: ['ui:show_type_menu'],
            on: {
              ON_BLUR_TYPE_MENU: "Waiting for user's action",

              ON_CHANGE_TYPE: {
                target: 'Type Menu Selected',
                internal: true,
                actions: ['assignMenuTypeToContext', 'effectUpdateSlateNode'],
              },
            },
          },
        },
        on: {
          ON_SETTING_MENU_BLUR: {
            target: 'Idle',
            actions: 'cleanUpContext',
          },
        },
      },

      'Waiting canvas event for setting menu': {
        after: {
          50: 'Showing Setting Menu',
        },

        description: 'When the user clicking the `item` from `DreamEditor`\'s canvas, the canvas also trigger `ON_SETTING_MENU_BLUR` event. That event will close the setting menu. So we need to wait for the canvas event before showing the setting menu.',
      },

      'Showing Logo Select Media': {
        tags: ['ui:show_logo_select_media'],

        on: {
          ON_SETTING_MENU_BLUR: 'Idle',
          ON_BACK_TO_SETTING_MENU: 'Waiting canvas event for setting menu',
        },

        states: {
          Idle: {
            on: {
              ON_CHANGE_LOGO: {
                target: 'Idle',
                actions: ['assignLogoToContext', 'effectUpdateSlateLogo'],
              },

              ON_UPLOAD_IMAGE: 'Uploading image',

              ON_CHANGE_LOGO_SIZE: {
                target: 'Idle',
                internal: true,
                actions: ['assignLogoSizeToContext', 'effectUpdateSlateNode'],
              },
            },
          },

          'Uploading image': {
            tags: ['ui:show_loading_upload_image'],
            invoke: {
              src: 'uploadImage',

              onDone: {
                target: 'Idle',
                actions: ['assignLogoToContext', 'effectUpdateSlateLogo'],
              },

              onError: 'Idle',
              id: 'uploadImage',
            },
          },
        },

        initial: 'Idle',
      },

      'Waiting canvas event for select media': {
        after: {
          50: 'Showing Logo Select Media',
        },

        description: 'This is transition state, its purpose is the same as \'Waiting canvas event for setting menu\'',
      },
    },
    schema: {
      services: {} as MachineServices,
      context: {} as MenuOptionsContext,
      events: {} as
        | { type: 'ON_CLICK_ITEM', newMenuRef: Path, newData: { newNavbar: Navbar2Element, menuType: MenuType, menuIndex?: number } }
        | { type: 'ON_CLICK_LOGO_ELEMENT', newMenuRef: Path, newData: { newNavbar: Navbar2Element, menuType: MenuType } }
        | { type: 'ON_SELECT_TITLE' }
        | { type: 'ON_CHANGE_TITLE', newTitle: string }
        | { type: 'ON_BLUR_TITLE' }
        | { type: 'ON_CLICK_FONT' }
        | { type: 'ON_CLICK_TEXT_COLOR_MENU' }
        | { type: 'ON_CLICK_BACKGROUND_COLOR_MENU' }
        | { type: 'ON_CLICK_LOGO_MENU' }
        | { type: 'ON_SETTING_MENU_BLUR' }
        | { type: 'ON_CHANGE_COLOR', newColor: string }
        | { type: 'ON_CHANGE_BACKGROUND_COLOR', background: string }
        | { type: 'ON_BLUR_COLOR_MENU' }
        | { type: 'ON_BLUR_BACKGROUND_COLOR_MENU' }
        | { type: 'ON_CHANGE_FONT', newFont: string }
        | { type: 'ON_BLUR_FONT_MENU' }
        | { type: 'ON_BACK_TO_SETTING_MENU' }
        | { type: 'ON_NAVBAR_INITIALIZED', initialNavbar: Navbar2Element }
        | { type: 'ON_CHANGE_LOGO', newLogo: NavbarBrandLogo }
        | { type: 'ON_UPLOAD_IMAGE', newFile: File }
        | {
          type: 'ON_CHANGE_LINK',
          newLink: {
            url: string,
            pageID?: string,
            pagePath?: string,
          }
        }
        | { type: 'ON_SELECT_LINK_MENU' }
        | { type: 'ON_BLUR_LINK_MENU' }
        | { type: 'ON_CHANGE_LINK_OPEN_NEW_TAB', newLinkOpenInNewTab: boolean }
        | { type: 'ON_DELETE_MENU', menuType: MenuType, menuIndex: number }
        | { type: 'ON_SELECT_TYPE_MENU' }
        | { type: 'ON_BLUR_TYPE_MENU' }
        | { type: 'ON_CHANGE_LOGO_SIZE', newLogoScale: number }
        | {
          type:
          'ON_CHANGE_TYPE',
          newMenuItemType: NavbarItem['type']
        },
    },
    context: {
      optionsColors: {},
      optionsFontFamilies: {},

      selectedFontFamily: 'inter', // Default to: DEFAULT_FONT_FAMILY_NAME

      // UI related state
      uiIsSidebarOpen: false,
      uiShowLinkSuggestion: false,
    }, // as MenuContext
    predictableActionArguments: true,
    preserveActionOrder: true,
  }, {
    guards: {
      isLogoExist: (context) => {
        // TODO(@ibedwi): check whether the current eleemnt is navbar brand
        if (!context?.dataNavbar?.logoType) {
          return false;
        }
        return true;
      },
      isNotNavbarBrand: (context) => {
        if (context?.menuType === 'brand') {
          return false;
        }
        return true;
      },
    },
  });
